<template>
  <div>
    <ToolbarAuth />
    <Navigation />

    <div class="mt-15 ml-15 mr-15">
      <v-card>
        <v-card-title class="primary--text text-uppercase">
          {{ $t("crud.add") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <ValidationObserver
            ref="obs"
            v-slot="{ invalid, validate, handleSubmit }"
          >
            <v-form ref="form">
              <v-row>
                <v-col sm-12 md="6">
                  <ValidationProvider
                    name="$t('users.gender')"
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <v-select
                      required
                      cache-items
                      :items="$t('gender.items')"
                      item-text="label"
                      item-value="value"
                      v-bind:label="$t('users.gender')"
                      outlined
                      :error-messages="errors"
                      :success="valid"
                      v-model="dataext.gender"
                      :menu-props="{ offsetY: true }"
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col sm-12 md-6>
                  <BaseValInput
                    rules="required|max:150"
                    v-model="dataext.first_name"
                    v-bind:label="$t('users.first_name')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <BaseValInput
                    rules="required|max:150"
                    v-model="dataext.last_name"
                    v-bind:label="$t('users.last_name')"
                  />
                </v-col>
                <v-col cols="12">
                  <BaseValInput
                    rules="required|email"
                    v-model.trim="dataext.email"
                    label="email"
                    @keyup="lowercase"
                  />
                </v-col>
                <v-col sm="12" md="6">
                  <ValidationProvider
                    v-bind:name="$t('crud.lang')"
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <v-select
                      required
                      :items="lang"
                      item-text="label"
                      item-value="value"
                      v-bind:label="$t('crud.lang')"
                      outlined
                      v-model="dataext.language"
                      :menu-props="{ offsetY: true }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-select>
                  </ValidationProvider>
                </v-col>

              </v-row>
              <div class="text-end mr-15">
                <v-btn color="accent" @click="closeItem()" class="mr-8"
                >{{ $t("crud.close") }}
                </v-btn>
                <v-btn
                  color="primary"
                  @click="handleSubmit(saveItem)"
                  :disabled="invalid || !validate"
                >{{ $t("crud.change") }}
                </v-btn>
              </div>
            </v-form>
          </ValidationObserver>
          <FlashMessage :error="error" v-if="error" key="error" />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import BaseValInput from "@/components/input/BaseValInput";
import { ValidationObserver } from "vee-validate";
import FlashMessage from "@/components/input/FlashMessage";
import { getError } from "@/utils/helpers";
import { ValidationProvider } from "vee-validate";
import FchartmemberService from "@/services/fchart/FchartmemberService";

export default {
  name: "Users",
  components: {
    FlashMessage,
    BaseValInput,
    ToolbarAuth,
    Navigation,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      disableBtn : false,
      error: null,
      dataext: {},
      lang: [
        { label: "Nederlands", value: "nl" },
        { label: "English", value: "en" },
      ],
    };
  },
  methods: {
    lowercase() {
      this.dataext.email = this.dataext.email.toLowerCase();
    },
    getData() {
      let Id = this.$route.params.id;
      this.loading = true;
      this.disableBtn = true;
      FchartmemberService.getMain(Id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => {
            this.loading = false;
            this.disableBtn = false;
          });
    },
    saveItem() {
      let Id = this.$route.params.id;
      const payload = {
        gender: this.dataext.gender,
        first_name: this.dataext.first_name,
        last_name: this.dataext.last_name,
        email: this.dataext.email,
        language: this.dataext.language,

      };
      this.error = null;

      FchartmemberService.updateMain(Id, payload)
        .then(() => {

          let id = this.$route.params.famId;
          this.$router.replace({
            name: "fchartMemberIndex",
            params: { famId: id },
          });
        })
        .catch((error) => (this.error = getError(error)))
        .finally(() => {
// eslint-disable-next-line no-undef
          EventBus.$emit("succes", true);
          console.log("ok dan");

        });
    },

    closeItem() {
      let id = this.$route.params.famId;
      this.$router.replace({
        name: "fchartMemberIndex",
        params: { famId: id },
      });
    },
  },
  computed: {

  },
  created() {
    this.getData();
  },
};
</script>

<style scoped></style>
